import React, { useState } from 'react';

const DropdownItem = ({
  label,
  value,
  onClick,
  style: overwriteStyle = {},
  hoverStyle = {},
  disabled,
  ...attr
}) => {
  const [hover, setHover] = useState(false);
  const handleClick = () => {
    onClick({ value, label, style: overwriteStyle });
  };

  const handleMouseEnter = () => {
    setHover(true);
  };

  const handleMouseLeave = () => {
    setHover(false);
  };

  if (disabled) {
    return (
      <div
        style={{
          ...styles.container,
          ...overwriteStyle,
          ...styles.disabledOption,
        }}
      >
        <span style={styles.disabledText}>
          {label}
        </span>
      </div>
    );
  }

  return (
    <div
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{
        ...styles.container,
        ...overwriteStyle,
        ...hover && {
          ...styles.hover,
          ...hoverStyle,
        },
      }}
      {...attr}
    >
      {label}
    </div>
  );
};

const styles = {
  container: {
    padding: 14,
    cursor: 'pointer',
    backgroundColor: 'white',
    textAlign: 'left',
  },
  hover: {
    backgroundColor: '#e0e0e0',
  },
  disabledOption: {
    pointerEvents: 'none',
  },
  disabledText: {
    opacity: 0.4,
  },
};

export default DropdownItem;
